import React from "react";

import GradesTable from "./Grades";
import GradeModal from "./GradeModal";

const Grades = () => (
    <>
        <GradesTable />
        <GradeModal />
    </>
  );

export default Grades;